import {
    KEYCLOAK_ADMIN_ROLE
  } from "@constants/keycloak";
  import { useKeycloak } from "@react-keycloak/web";
  import { useMemo } from "react";
  
  export const useKeycloakAdmin = (): boolean => {
    const { keycloak } = useKeycloak();
  
    const hasKeycloakAdmin: boolean = useMemo(() => {
      const userRoles = keycloak.realmAccess?.roles || [];
      return userRoles.includes(KEYCLOAK_ADMIN_ROLE);
    }, [keycloak.realmAccess]);
  
    return hasKeycloakAdmin;
  };
  